(function(win) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var tid;

  const baseSize = 32

  function refreshRem() {
    // 获取屏幕宽度
    // var width = docEl.getBoundingClientRect().width;
    // var rem = width / 750;  // 将屏幕宽度分成7.5份， 1份为1rem
    // docEl.style.fontSize = rem + 'px';

    const scale = document.documentElement.clientWidth / 750
    // 设置页面根节点字体大小
    docEl.style.fontSize = baseSize * Math.min(scale, 2) + 'px'


  }

  win.addEventListener('resize', function() {
    clearTimeout(tid);
    tid = setTimeout(refreshRem, 10);
  }, false)
  win.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 10);
    }
  }, false);

  refreshRem();

})(window)
